module.exports = __webpack_public_path__ + "static/media/ico-close.8d8d9460.svg";